<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
          v-divider
          AttachmentList(:title='title' :dialogType='dialogType' :ip='ip')
</template>

<script>
import * as config from "../config/index.json";
import AttachmentList from '@/components/AttachmentList.vue';
import { mapState } from "vuex";
import helper from "../helper/index.js";
export default {
  name: "MyAttachmentApprovalList",
  components: {
    AttachmentList
  },
  data () {
    return {
      config: config.default,
      title: 'My Attachment Approval List',
      dialogType: 'approval',
      ip: {
        headers: [
          {
            text: 'Judul',
            align: 'start',
            sortable: false,
            value: 'ipTitle',
          },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Perusahaan', value: 'ipPerusahaan' },
          { text: 'Jenis Kendaraan', value: 'ipJenisKendaraan' },
          { text: 'Model Kendaraan', value: 'ipModelKendaraan' },
          { text: 'Status', value: 'ipStatusLabel', align: 'center', width: '120px'},
          { text: 'Action', value: 'actions' },
          { text: '', value: 'data-table-expand' }
        ],
        items: []
      }      
    }
  },
  mounted() {
    this.$store.dispatch("fetchMyAttachmentApproval").then((data) => {
      this.ip.items = data
      for (let i = 0; i < this.ip.items.length; i++) {
        this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
        this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
        if (this.ip.items[i].ipStatus == 2) {
          let workflow = this.ip.items[i].ipWorkflow;
          for (let j = 0; j < workflow.length; j++) {
            if (this.$store.getters.isAuthenticated && (workflow[j].status == 9 && workflow[j].approverId == this.$store.state.dataUsers.nik)) {
              this.ip.items[i].ipStatusLabel = this.config.status[workflow[j].status].name;
              this.ip.items[i].ipStatusColor = workflow[j].status;
              break;
            }
          }
        }
        this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
        this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
      }
      return this.ip;
    });
  },
  computed: {
    ...mapState(["myApprovalAttachment"])
  },
  methods: {
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate
  }
};
</script>
